import React from 'react';

import caution from '../../../assets/caution-alert.svg';
import warning from '../../../assets/error-warning.svg';
import SyncInstallUpdatesSection from '../sync-install-updates-section/sync-install-updates-section';
import {
    SyncMapsCard,
    SyncMapStatus,
} from '../../../views/sync-maps-updates-view/hooks/use-syncs-maps-status-updates';
import SyncInstallUpdatesCard from '../sync-install-updates-card/sync-install-updates-card';
import AccordionItem from '../../../support/components/AccordionItem/AccordionItem';

interface Props {
    title: string | undefined;
    subtitle: string | undefined;
    disabled: boolean | undefined;
    syncMapContent: SyncMapStatus | null | undefined;
    radioButtons: boolean | undefined;
    setSelectedOption?: (event: any) => void;
    selectedOption?: string;
    syncGeneration?: string;
    hasVw?: boolean;
    version?: boolean;
    downloadUrl?: string;
    eulaURL?: string;
    accordionType: string | undefined;
    cards: SyncMapsCard[];
    hasCtr?: boolean;
    heading: string | undefined;
    isNA: boolean;
}

export const SyncMapsUpdateAccordionItemContainer = (props: Props) => {
    const sortedCards = [...props.cards].sort((a, b) =>
        +a.step < +b.step ? -1 : 1
    );
    return (
        <>
            <AccordionItem
                title={props.title}
                accordionIMG={
                    <img
                        className="accordion-heading-icon"
                        src={
                            (props.isNA && props.accordionType === 'maps') ||
                            props.syncGeneration === '4' ||
                            props.syncGeneration === '5'
                                ? caution
                                : warning
                        }
                        alt=""
                    />
                }
                subtitle={props.subtitle}
                disabled={props.disabled}
                role="button"
            >
                {props.syncMapContent &&
                    props.radioButtons &&
                    props.setSelectedOption &&
                    (props.syncGeneration || props.hasVw) && (
                        <SyncInstallUpdatesSection
                            syncMapsContent={props.syncMapContent}
                            setSelectedOption={props.setSelectedOption}
                            selectedOption={props.selectedOption || ''}
                            genId={props.syncGeneration || ''}
                            version={props.version}
                            isCtr={props.hasCtr}
                            isVw={props.hasVw}
                        />
                    )}
                {sortedCards?.length > 0 &&
                    sortedCards.map((card: SyncMapsCard, index: number) => (
                        <div key={`${props.heading}`}>
                            <SyncInstallUpdatesCard
                                {...card}
                                downloadUrl={props.downloadUrl}
                                logFileError={
                                    props.syncMapContent?.logFileError
                                }
                                eulaURL={props.eulaURL}
                                accordionType={props.accordionType}
                                selectedOption={props.selectedOption}
                                pendingLogFileErrorMessage={
                                    props.syncMapContent?.pendingLogFileError
                                }
                                uploadPending={
                                    props.syncMapContent?.uploadPendingMessage
                                }
                                xmlVinMismatchMessage={
                                    props.syncMapContent?.xmlVinMismatchMessage
                                }
                                genId={props.syncGeneration || ''}
                            />
                            {index !== props.cards.length - 1 && (
                                <hr className="sync-updates-steps-divider" />
                            )}
                        </div>
                    ))}
            </AccordionItem>
        </>
    );
};
